import validate from "/app/code/web-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import authentication from "/app/code/web-frontend/modules/core/middleware/authentication.js";
import enterpriseExtraClientScripts from "/app/code/enterprise/web-frontend/modules/baserow_enterprise/middleware/extraClientScripts.js";
import manifest_45route_45rule from "/app/code/web-frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  authentication,
  enterpriseExtraClientScripts,
  manifest_45route_45rule
]
export const namedMiddleware = {
  settings: () => import("/app/code/web-frontend/modules/core/middleware/settings.js"),
  authenticated: () => import("/app/code/web-frontend/modules/core/middleware/authenticated.js"),
  workspacesAndApplications: () => import("/app/code/web-frontend/modules/core/middleware/workspacesAndApplications.js"),
  pendingJobs: () => import("/app/code/web-frontend/modules/core/middleware/pendingJobs.js"),
  staff: () => import("/app/code/web-frontend/modules/core/middleware/staff.js"),
  impersonate: () => import("/app/code/web-frontend/modules/core/middleware/impersonate.js"),
  urlCheck: () => import("/app/code/web-frontend/modules/core/middleware/urlCheck.js"),
  redirectCompletedOnboarding: () => import("/app/code/web-frontend/modules/core/middleware/redirectCompletedOnboarding.js"),
  selectWorkspaceDatabaseTable: () => import("/app/code/web-frontend/modules/database/middleware/selectWorkspaceDatabaseTable.js"),
  selectDashboard: () => import("/app/code/web-frontend/modules/dashboard/middleware/selectDashboard.js"),
  selectWorkspaceBuilderPage: () => import("/app/code/web-frontend/modules/builder/middleware/selectWorkspaceBuilderPage.js"),
  exchangePreviewToken: () => import("/app/code/web-frontend/modules/builder/middleware/exchangePreviewToken.js"),
  userSourceAuthProviderCallback: () => import("/app/code/web-frontend/modules/builder/middleware/userSourceAuthProviderCallback.js"),
  selectWorkspaceAutomationWorkflow: () => import("/app/code/web-frontend/modules/automation/middleware/selectWorkspaceAutomationWorkflow.js")
}